/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {ConfirmModalGeneralComponent} from './confirm-modal-general.component';
import {CommonModule} from '@angular/common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [
        ConfirmModalGeneralComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ConfirmModalGeneralComponent
    ],
    providers: [
        NgbActiveModal
    ]
})
export class ConfirmModalGeneralModule {
}
